import ReactPlayer, { ReactPlayerProps } from 'react-player';
import { useCallback, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export interface CloudinaryVideoPlayerProps extends ReactPlayerProps {
  url: string;
  thumbnailImage?: string;
  wrapClassName?: string;
}

const VIDEO_COMPLETION_PERCENT = 0.8;

function CloudinaryVideoPlayer({ url, thumbnailImage, wrapClassName, ...rest }: CloudinaryVideoPlayerProps) {
  const [isCompleted, setIsCompleted] = useState(false);

  const handleVideoProgress = useCallback(
    ({ played }) => {
      if (played >= VIDEO_COMPLETION_PERCENT && !isCompleted) {
        setIsCompleted(true);
      }
    },
    [isCompleted, url],
  );

  return (
    <div className={twMerge('aspect-video bg-blackDarkest', wrapClassName)}>
      <ReactPlayer
        width="100%"
        height="100%"
        controls
        {...(thumbnailImage
          ? {
              playing: true,
              light: thumbnailImage,
            }
          : {})}
        {...rest}
        url={url}
        onProgress={handleVideoProgress}
      />
    </div>
  );
}

export default CloudinaryVideoPlayer;
